import Recipe from '~/components/Recipe.vue'
import DoccurateItemToPalletCarton from '~/components/recipes/DoccurateItemToPalletCarton.vue'
import DoccurateItemToPalletPremadePallet from '~/components/recipes/DoccurateItemToPalletPremadePallet.vue'

const recipeList = [
  'Recipe',
  'DoccurateItemToPalletCarton',
  'DoccurateItemToPalletPremadePallet'
]

export const recipeManifest = {
  components: {
    Recipe,
    DoccurateItemToPalletCarton,
    DoccurateItemToPalletPremadePallet
  },
  data () {
    return {
      recipeList
    }
  },
  methods: {
    componentForRecipe (recipeName) {
      for (const recipe of this.recipeList) {
        console.log(`${recipeName} ${recipe}`)
        if (this.kebabToPascal(recipeName) === recipe) {
          return recipeName
          // return recipe
        }
      }
      return 'recipe'
    },
    kebabToPascal (s) {
      if (s) {
        return s.replace(/(^\w|-\w)/g, c => `${c[c.length - 1].toUpperCase()}`)
      }
      return ''
    }
  }
}
